// constants, class definitions, and librarie
import * as createjs from "createjs-module";
import * as symConst from 'src/app/shared/constant/canvasSymTypes'; 
import {STATE_ROOT_FIRST, STATE_OPEN_FILE,TAB_UNIT_WIDTH,STATE_ROOT_FIRST,KEY_ID_ALT_E,
  STATE_IN_GRID_FRACTION_DEN, STATE_IN_GRID_FRACTION_NUM, STATE_NORMAL, STATE_IN_PEN_TOOL,
  STATE_IN_PEN_TOOL} from 'src/assets/js/cv-classes.js';
import  {FONT_DEFAULT ,FONT_ALT , FONT_MATH ,FONT_SPEC_1 , FONT_ITALIC , FONT_SPEC_2,FONT_WITH_BOLD,
  FONT_WINGDINGS , FONT_GEO_NOTO, FONT_GEO_DEJAVU, DISPLAY_TYPE_GRID, DISPLAY_TYPE_LINE,DISPLAY_TYPE_TEXT,UNITS_GRID_SCALE,
  SIZE,FONT_INDEX,undoStackType, undoStackBranch,undoStackBranch,START_LINESEG_DOT, CV_BACKGROUND_COLOR} 
  from 'src/app/shared/constant/drawConstants';
import * as createjs from "createjs-module";

// functions called and variables
import {db,stage} from 'src/assets/js/draw.js';
import {drawCursor,drawTreeCursor} from 'src/assets/js/cv-graphics-mouse.js';
import { DT_END_POINT_DOT,  DT_END_POINT_OPEN_DOT,DT_END_POINT_ARROW,
    DT_END_POINT_ARROW_DOT,DT_SHAPE_SOLID,DT_HIGHLIGHT_OFF,DT_HIGHLIGHT_ON,DT_TOOL_LINE,
    DT_LINE_TYPE_DASHED,DT_LINE_TYPE_DOTTED,DT_TOOL_MULTI_LINE,DT_MULTI_LINE_CLOSED,
    DT_TOOL_SHAPE,DT_TOOL_POINT,
    DT_TOOL_FREEHAND} 
    from 'src/app/shared/constant/draw-tool-api'; 
import { drawOneABCBox } from "./cv-text";



/**
 * function dostageUpdate will call srage.update() when state is not in OPEN_FILE
 * added to improve efficiency and eliminate unneeded stage refreshes
 */
export function doStageUpdate() {
  if (db.state != STATE_OPEN_FILE) {
    stage.update();
  }
}

export function movePenLayerToTop() {

  if (db.inIpad) {
    db.stageDragContainer.setChildIndex(db.penLayer, db.stageDragContainer.numChildren-1);
  }
  else {
    stage.setChildIndex(db.penLayer, stage.numChildren-1);
  }
}

export function movePenLayerBehindMath() {

  // count which ohter layers need to be in the background to determine where the penLayer needs to go when not active
  // if there is a file image that takes up one layer
  let index = (db.fileImage) ? 2 : 1;

  // if in iPad, then there is a dark background that takes up a layer, and then everything else has to reside within the drag container
  // but since the penlayer has to be a child of the drag container, then the dark background isn't added
  if (db.inIpad) {
    //index += 1; 
    db.stageDragContainer.setChildIndex(db.penLayer, index);
  }
  else {
    stage.setChildIndex(db.penLayer, index);
  }
 
}

// for background and surround boxes that are created to allow mouse clicks, match the color to the 
// canvas page or white for on PDFs
export function getFillColor(createjsShape) {

  // if on an image then set background boxes to near white, otherwise set them to the canvas page background color
    let color;
    if (db.fileImage == null) {
      color = db.userPrefs.backgroundColor;
      if (createjsShape != null) 
        createjsShape.alpha = .01;
    }
    else {
      color = CV_BACKGROUND_COLOR;
      if (createjsShape != null) 
        createjsShape.alpha = .01;
    }
  return (color);
}

// set the color for a single symbol based on user prefs color settings
export function setSymColor(keyID,typeCode)  {

  let color = db.userPrefs.cvMainColor;
      
        if (typeCode == symConst.CV_EQUALS_INQ_TYPE ){
          color = db.userPrefs.cvEqualsColor;
        }
        else if (keyID == symConst.KEY_ID_NEGATIVE_SIGN) {
        color = db.userPrefs.cvEqualsColor;
        }
        else if (typeCode == symConst.CV_OPERATOR_TYPE) {
          color = db.userPrefs.cvOperatorsColor;
        }
        else if (typeCode == symConst.CV_TEXT_TO_LINE) {  
          color = db.userPrefs.cvTextColor;
        }

  return(color);
}

export function checkLev3Mode(newPID) {
  // check if it's a level 3 file and last problem is grid, and if so then notify sideboard to switch to grid view
  let switchMode = false;
  if (db.mathLevel == 3 && newPID >= 0 && db.curProb.displayType != db.mProb[newPID].displayType) {
    if ((db.lev3UseGrid && db.mProb[newPID].displayType == DISPLAY_TYPE_LINE) ||
      (!db.lev3UseGrid && db.mProb[newPID].displayType == DISPLAY_TYPE_GRID)) {

      db.displayType = db.mProb[newPID].displayType;
      db.lev3UseGrid = (db.displayType == DISPLAY_TYPE_GRID) ? true : false;
      switchMode = db.mProb[newPID].displayType;
    }
  }
  return (switchMode);
}

export function checkMatch(displayType) {

  let match = true;

  if ((displayType == DISPLAY_TYPE_LINE && (db.mathLevel == 1 || db.mathLevel == 2)) ||
      (displayType == DISPLAY_TYPE_GRID && db.mathLevel == 4)) {
        match = false;
      }

  return (match);
}

export function pushPenItemPt(penItem, x,y) {
  let point = new createjs.Point(x,y);
  penItem.points.push(point);

}

export function penItemFindStartY(penItem) {

  let yLoc = penItem.container.y;

  switch (penItem.dt.toolType) {
    case DT_TOOL_POINT:
    case DT_TOOL_SHAPE:
      yLoc += penItem.shape.y;
      break;
    case DT_TOOL_LINE:
    case DT_TOOL_MULTI_LINE:
    case DT_TOOL_FREEHAND:
      yLoc += penItem.points[0].y;
      break;
  }

  return(yLoc)
}

// when drawing lines with drawtool, adjust the line length if end type
// is open circle so line starts past circle
export function adjustStart(penItem,startPt, endPt,forArrow) {

  let newPt = new createjs.Point(startPt.x, startPt.y);
  
  if (penItem.dt.toolType == DT_TOOL_MULTI_LINE && penItem.dt.jointType == DT_MULTI_LINE_CLOSED) {
    return(startPt);
  }
  else {
     if (penItem.dt.lineStartType ==  DT_END_POINT_OPEN_DOT || penItem.dt.lineStartType == DT_END_POINT_ARROW) {
      newPt = calcDirectionVectorPoint(startPt.x, startPt.y, endPt.x, endPt.y, 2+penItem.dt.regLineSize);
    }
    else if (penItem.dt.lineStartType == DT_END_POINT_ARROW_DOT) {
      //newPt = calcReverseDirectionVectorPoint(startPt.x, startPt.y, endPt.x, endPt.y, 15+penItem.dt.regLineSize);
    //}
      if (forArrow) {
        //newPt = calcReverseDirectionVectorPoint(startPt.x, startPt.y, endPt.x, endPt.y, 30+2*penItem.dt.regLineSize);
        newPt = calcReverseDirectionVectorPoint(startPt.x, startPt.y, endPt.x, endPt.y, 30+3*penItem.dt.regLineSize);
      }
      else {
        //newPt = calcReverseDirectionVectorPoint(startPt.x, startPt.y, endPt.x, endPt.y, 30+ (1.2*penItem.dt.regLineSize));
        newPt = calcReverseDirectionVectorPoint(startPt.x, startPt.y, endPt.x, endPt.y, 30+penItem.dt.regLineSize);
    
      }
    } 

  return(newPt);
  }
}

// adjust the length of a line or multiLine for draw tool to not overlap the end symbol
export function adjustEnd(penItem,startPt, endPt, forArrow) {

  let newPt = new createjs.Point(startPt.x, startPt.y);

  if (penItem.dt.toolType == DT_TOOL_MULTI_LINE && penItem.dt.jointType == DT_MULTI_LINE_CLOSED) {
    return(startPt);
  }
  else {
    if (penItem.dt.lineEndType ==  DT_END_POINT_OPEN_DOT || penItem.dt.lineEndType == DT_END_POINT_ARROW) {
      newPt = calcDirectionVectorPoint(startPt.x, startPt.y, endPt.x, endPt.y, 2+penItem.dt.regLineSize);
    }
    else if (penItem.dt.lineEndType == DT_END_POINT_ARROW_DOT) {
      if (forArrow) {
        //newPt = calcReverseDirectionVectorPoint(startPt.x, startPt.y, endPt.x, endPt.y, 30+2*penItem.dt.regLineSize);
        newPt = calcReverseDirectionVectorPoint(startPt.x, startPt.y, endPt.x, endPt.y, 30+3*penItem.dt.regLineSize);
      }
      else {
        //newPt = calcReverseDirectionVectorPoint(startPt.x, startPt.y, endPt.x, endPt.y, 30+ (1.2*penItem.dt.regLineSize));
        newPt = calcReverseDirectionVectorPoint(startPt.x, startPt.y, endPt.x, endPt.y, 30+ (penItem.dt.regLineSize));
        }
      //newPt = calcDirectionVectorPoint(endPt.x, endPt.y, startPt.x, startPt.y, 2+penItem.dt.regLineSize);
    }
    return(newPt);
  }
}

// function to set the correct fill color of a pen object
// based on highlight or regular being
export function setPenShapeFill(newShape,pen,alwaysFill) {

  if ((pen.toolType == DT_TOOL_SHAPE && pen.shapeFill == DT_SHAPE_SOLID) || alwaysFill)  {
    if (pen.highlight == DT_HIGHLIGHT_ON  && 
      (pen.toolType == DT_TOOL_LINE || pen.toolType == DT_TOOL_MULTI_LINE)) {
        newShape.graphics.beginFill(pen.highlightColor); 
        newShape.graphics.alpha = pen.lineOpacity;
    }
    else {
      newShape.graphics.beginFill(pen.regColor); 
    }
  }
  

}

// function to set the correct line stroke size and color of pen object
// based on highlight or regular being current
export function setPenShapeStroke(newShape,pen, setRound) {

  let color, size;
  if (pen.highlight == DT_HIGHLIGHT_ON  && 
      (pen.toolType == DT_TOOL_LINE || pen.toolType == DT_TOOL_MULTI_LINE)) {
    color = pen.highlightColor;
    size = pen.highlightLineSize;
    newShape.alpha = pen.lineOpacity;
  }
  else {
    color = pen.regColor;
    size = pen.regLineSize;
  }

  // skip doing stroke on shapes that are highlighted since opacity overlaps oddly
  if (pen.toolType == DT_TOOL_SHAPE && pen.highlight == DT_HIGHLIGHT_ON
      && pen.shapeFill == DT_SHAPE_SOLID) {
    return(size);
  }

  if (setRound) {
    newShape.graphics.setStrokeStyle(size,'round', 'round');
    newShape.graphics.beginStroke(color);
  }
  else {
    if (pen.highlight == DT_HIGHLIGHT_OFF && pen.lineStyle == DT_LINE_TYPE_DOTTED) {
      newShape.graphics.setStrokeStyle(size, 'round').beginStroke(color);
    }
    else {
      newShape.graphics.setStrokeStyle(size).beginStroke(color); 
    }
  }

  //also set the dashed setting for regular lines
  if (pen.highlight == DT_HIGHLIGHT_OFF) {
    setPenDash(newShape, pen, size); 
  }
  return(size);
}

function setPenDash(newShape, pen, size) {

  let dashLength;
  let gapLength;

  if (pen.lineStyle ==DT_LINE_TYPE_DASHED ) {
    // make dashes on middle px sizes a little longer
    if (size > 3 && size < 9) {
      size += 3;
    }
    let dashLength = Math.max(10,size*2);
    let gapLength = Math.max(5,size);

    newShape.graphics.setStrokeDash([dashLength,gapLength]);
  }
  else if (pen.lineStyle ==DT_LINE_TYPE_DOTTED) {
    size = Math.min(size,16);
    newShape.graphics.setStrokeDash([1,size*3]);
  }
}
// function to set the correct line stroke size and color of pen object
// based on highlight or regular being current
export function checkPenShapeStroke(pen) {

  let color, size;
  if (pen.highlight == DT_HIGHLIGHT_OFF) {
    color = pen.regColor;
    size = pen.regLineSize;
  }
  else {
    //color = rgba(233, 161, 199, 0.4);  //pen.highlightColor;
    color = pen.highlightColor;
    size = pen.highlightLineSize;
  }

   return(size);
}

// function to set the correct line stroke size and color of pen object
// based on highlight or regular being current
export function checkPenShapeColor(pen) {

  let color, size;
  if (pen.highlight == DT_HIGHLIGHT_OFF) {
    color = pen.regColor;
    size = pen.regLineSize;
  }
  else {
    //color = rgba(233, 161, 199, 0.4);  //pen.highlightColor;
    color = pen.highlightColor;
    size = pen.highlightLineSize;
  }

   return(color);
}

// routine to figure out the distance to change the line length, from chatGPT
  function calcDirectionVectorPoint(startX, startY, endX, endY, distance) {
    // Calculate the direction vector
    var dx = endX - startX;
    var dy = endY - startY;

    // Calculate the length of the direction vector
    var length = Math.sqrt(dx * dx + dy * dy);

    // Normalize the direction vector (make it unit length)
    var unitDx = dx / length;
    var unitDy = dy / length;

    // Scale the direction vector to the desired distance
    var scaledDx = unitDx * distance;
    var scaledDy = unitDy * distance;

    // Calculate the new point by adding the scaled direction vector to the start point
    var newX = startX + scaledDx;
    var newY = startY + scaledDy;

    return { x: newX, y: newY };
}

// routine to figure out the distance to change the line length, from chatGPT
function calcReverseDirectionVectorPoint(startX, startY, endX, endY, distance) {
  // Calculate the direction vector
  //var dx = endX - startX;
  //var dy = endY - startY;
  var dx = startX - endX;
  var dy = startY - endY;

  // Calculate the length of the direction vector
  var length = Math.sqrt(dx * dx + dy * dy);

  // Normalize the direction vector (make it unit length)
  var unitDx = dx / length;
  var unitDy = dy / length;

  // Scale the direction vector to the desired distance
  var scaledDx = unitDx * distance;
  var scaledDy = unitDy * distance;

  // Calculate the new point by adding the scaled direction vector to the start point
  var newX = startX + scaledDx;
  var newY = startY + scaledDy;

  return { x: newX, y: newY };
}

export function hideCursor() {
  if (db.cursor != null) {
    db.cursor.visible = false;
    stage.update();
  }
}

export function showCursor() {
  if (db.cursor != null) {
    db.cursor.visible = true;
    stage.update();
  }
}


export function isClickNearSelectBoxFromMenu(startX, startY) {

let isNear = false; 
let point = getCorrectXY(db.selectionArea.resizeDot);

let nearX = Math.abs(point.x) < (db.curProb.gridW * db.curProb.probScale);
let nearY = Math.abs(point.y) < (db.curProb.gridH * db.curProb.probScale);

isNear = nearX && nearY;
return (isNear);
}

// determine if current math cursor position is at the end of a line

export function isLineProbAtEndLine(line) {

  let onLastBranch = false;
  let atEnd = false;
  let lastBranch;
  let lastSymIndex = line.sym.length-1

  if (line.sym[lastSymIndex].type == symConst.CV_BRANCHING_GRP) {
    lastBranch = line.sym[lastSymIndex].branch[last.sym[lastSymIndex].length-1];
    onLastBranch = (db.curBranch == lastBranch);
    if (onLastBranch) {
      atEnd = lastBranch.sIndex >= lastBranch.sym.length-1
    }
  }
  else {
   onLastBranch = (db.curBranch == line);
   if (onLastBranch) {
    atEnd = line.sIndex >= line.sym.length-1;
   }
  
  }

  return (atEnd);
}

export function adjustSymSpacingFromKeyboard(newSym) {
  
if (db.curBranch.sym[db.curBranch.sIndex] != null && db.curBranch.sym[db.curBranch.sIndex].type == symConst.CV_ABC_TYPE
  && db.curBranch.sym[db.curBranch.sIndex].groupCode == symConst.CV_SPEC2_GRP && db.curBranch.sym[db.curBranch.sIndex].str == 'd') {
  
    if (newSym.str == "x" || newSym.str == "y" || newSym.str == "t" ) {
      newSym.symOffsetX=0;
      newSym.width = .7;
    }
  }
  
}  


export function checkForTallParen(newSym) {
  
  if (newSym.str == symConst.KEY_ID_PAREN_RIGHT) {
    if (db.curLine.openLeftParen > 0) {
      if (db.curLine.makeParenTall) {
        newSym.tall = true;
        db.curLine.makeParenTall = false;
      }
      db.curLine.openLeftParen = -1;
    }
  }
  if (newSym.str == symConst.KEY_ID_PAREN_LEFT) {
    db.curLine.openLeftParen = db.curLine.sIndex+1;
  }
  if (newSym.str == symConst.KEY_ID_FRACTION && db.curLine.openLeftParen >= 0) {
      db.curLine.makeParenTall = true;
      let sym = db.curLine.sym[db.curLine.openLeftParen];
      sym.tall = true;
      let font = getSymFont (symConst.KEY_ID_PAREN_LEFT,symConst.CV_BRACKET_TYPE,false,true)
      sym.displayText.font = font;
     
      doStageUpdate(); 
    }
    
  }
 

/**
 * function findLineSegDotIndex returns the grid index that the passed in
 * line segment dot is, based on current problem grid size - level 1-2 only
*
 */
export function findLineSegDotIndex(dot,dotType) {

let startIndex;

  if (dotType == START_LINESEG_DOT) {
    startIndex = dot.x/(db.curProb.gridW); 
  }
  else {  // ending dots are at end of problems so need 1 substracted to get index
    startIndex = dot.x/(db.curProb.gridW)-1; 
  }
return(startIndex);
}
/**
 * function findSymInLine searches through the given line or branch of type DISPLAY_TYPE_LINE and 
 * returns the sIndex of the symbol position at stage coordinate xpos
 *
 */
/*
 export function findSymInLine(xpos, line) {
   let xposLocal = xpos - db.curProb.container.x; // add line and scale positions, change to createjs too
   let gridXpos = xposLocal / db.curProb.gridW;
   let countGrids = 0;
   let i = 0;
   while (i < line.sym.length-1 && countGrids < gridXpos) {
     countGrids += line.sym.width
     i++;
   }

   // return the index for the prior symbol, or -1 if none found
   let foundIndex = (countGrids > gridXpos) ? i-1 : -1 ; 
   
   return(foundIndex);
  }
  */

export function calcTabPos(priorTally) {
  
  let tempW = Math.trunc(priorTally);
  let temp2 = Math.trunc((tempW + TAB_UNIT_WIDTH)/TAB_UNIT_WIDTH);
  let tabWidth = temp2*TAB_UNIT_WIDTH-priorTally;

  return(tabWidth)

}

/**
 * function tallyLineSymWidth calculates the width in gridUnits of a line of symbols up to point sIndex
 *
 */
 export function tallyLineNobScale(line, sIndex) {
  
  let unitWidth = 0;

  for (let i=0; i <= sIndex ; i++) {
    if (line.sym[i].tabWidth != 0) {
      unitWidth += line.sym[i].tabWidth;
    }
    else {
      unitWidth += line.sym[i].width;
    }
   
  }
  let returnWidth = unitWidth;
  return(returnWidth);
}




/**
 * function tallyLineSymWidth calculates the width in gridUnits of a line of symbols up to point sIndex
 *
 */
export function tallyLineSymWidths(line, sIndex) {
  
  let unitWidth = 0;

  if (line.sym.length-1 >= sIndex) {

  for (let i=0; i <= sIndex ; i++) {
    if (line.sym[i].tabWidth != 0) {
      unitWidth += line.sym[i].tabWidth;
    }
    else {
      unitWidth += line.sym[i].width;
    }
    
  }

}

  return(unitWidth);
}

/**
 *  For during a selection for internal clipboard, set the symbol offsets to the distance from
 * the beginning xpos of this selection and from the starting symbol sIndex
 **/

export function calcSymOffsets(startX, sIndex) {

let tally = 0;
let line = db.curBranch;
//console.log(sIndex+1,startX, line);
for (let i = sIndex+1; i <= line.sym.length-1; i++) {
  line.sym[i].clipOffset = tally*db.curProb.gridW; // - startX;
  tally += line.sym[i].width;
  //console.log(line.sym[i].str,tally,line.sym[i].clipOffset);
 
}
if (sIndex == -1) {
  while (line.parent != null) {
    line = line.parent;
    let branchX = (line.isBranch) ? db.curBranch.container.x - line.container.x : db.curBranch.container.x;
    tally = 0;
    for (let j = 0; j <= line.sym.length-1; j++) {
      line.sym[j].clipOffset = tally*db.curProb.gridW - branchX;
      tally += line.sym[j].width;
      //console.log(line.sym[j].str, line.sym[j].clipOffset, tally);
    }
  }
}
//console.log(db.curLine);

}

/** find the sIndex in a branch that match an xpos in that branch coordinates
 * 
 */
export function findBranchClickIndex(xUnitPos) {
  xUnitPos *= db.curProb.probScale;
  let nextSymIndex = -1;
  let returnIndex;
  let finalSym = db.curBranch.sym.length-1;
  let widthTally = 0;
  //console.log("Pos passed in", xUnitPos,db.curBranch.lineWidth);

  if (db.curBranch.lineWidth == 0 ) {
    returnIndex = 0;
  }
  else if (xUnitPos <= 0) {
    returnIndex = 0;
  }
  else {
    if (xUnitPos > 0 && xUnitPos < db.curBranch.lineWidth) {
      while (++nextSymIndex <= finalSym && xUnitPos >= widthTally) {
        // if this is a tab symbol, use tab width instead of symbol width
        if (db.curBranch.sym[nextSymIndex].tabWidth != 0) {
          widthTally += db.curBranch.sym[nextSymIndex].tabWidth; 
        }
        else {
          
          widthTally += db.curBranch.sym[nextSymIndex].width; 
     
        }
      } 
      returnIndex = Math.max(nextSymIndex-1,0);  // if error condition of never going through loop, adjust to 0
    }
    else {
      returnIndex = finalSym;
    }
    
  }
   return(returnIndex);

}

/** find the sIndex in a branch that match an xpos in that branch coordinates
 * 
 */
export function findBranchClickIndexRightAdjusted(xUnitPos) {
  xUnitPos *= db.curProb.probScale;
  let nextSymIndex = -1;
  let returnIndex;
  let finalSym = db.curBranch.sym.length-1;
  let widthTally = 0;
  let priorRemainder= 0; 

  if (db.curBranch.lineWidth == 0 ) {
    returnIndex = 0;
  }
  else if (xUnitPos <= 0) {
    returnIndex = 0;
  }
  else {
    if (xUnitPos > 0 && xUnitPos < db.curBranch.lineWidth) {
      while (++nextSymIndex <= finalSym && xUnitPos >= widthTally) {
        // if this is a tab symbol, use tab width instead of symbol width
        if (db.curBranch.sym[nextSymIndex].tabWidth != 0) {
          widthTally += db.curBranch.sym[nextSymIndex].tabWidth; 
        }
        else {
          widthTally += priorRemainder;
          priorRemainder = db.curBranch.sym[nextSymIndex].width*.2;
          widthTally += db.curBranch.sym[nextSymIndex].width-priorRemainder; 
        }
        
      } 
      if (nextSymIndex > finalSym && xUnitPos >= widthTally) {
      returnIndex = nextSymIndex;
      }  
      else {   
        returnIndex = Math.max(nextSymIndex-1,0);  // if error condition of never going through loop, adjust to 0
      }
    }
    else {
      returnIndex = finalSym;
    }
    
  }
  return(returnIndex);

}



/**
 * function findBranchSymStartX returns for a branch in a line position
 * the top left start position of the grid of the sIndex sym in the branch coordinates
 * used in cross-off keys
 */
 export function findBranchSymStartX(branch,sIndex) {

  let unitWidth = tallyLineSymWidths(branch, sIndex);
  let symXStart = (db.curProb.gridW ) *unitWidth; //  no bscale here, works right
 

  return(symXStart);
}


/**
 * function findXposBranch returns for a branch in a line position
 * the x position of the symbol sIndex
 */
/*
export function findXposBranch(branch,sIndex) {

  let unitWidth = tallyLineSymWidths(branch, sIndex);
  let bGridW = db.curProb.gridW; // bscale already acconted for in tally * branch.bScale;
  let xpos =  branch.container.x + bGridW/2 + (bGridW * unitWidth);
  //console.log("helper ",sIndex,xpos,bGridW,branch.container.x);
  
  return(xpos);
}
*//*
export function findYposBranch(branch,sIndex) {

  let bGridH = db.curProb.gridH * branch.bScale;
  
  let ypos =  branch.container.y+  bGridH/2;  // add line height stuff
  
  //ypos = db.curProb.heightBelow;
  //console.log(branch.container.y);
  
  return(ypos);
}
*/
/** 
 *  set the xpos and ypos correctly for the current sIndex of db.curBranch in a DISPLAY_TYPE_LINE
 */
export function resetTreeXYPosAndCursor() {

  //console.log(db.curBranch);
  
  let point = new createjs.Point(0,0);
  let point2 = new createjs.Point(0,0);
  let point3 = new createjs.Point(0,0);
  let temp = 0;

  if (db.curBranch == null) {
    return;
  }
  else {
    let branchX = tallyLineSymWidths(db.curBranch, db.curBranch.sIndex)*(db.curProb.gridW/db.curProb.probScale);
  

  if (db.inIpad) {
    if (db.curBranch.isBranch) {
      point = db.curProb.container.localToLocal(branchX+db.curBranch.container.x/(db.curProb.probScale),
                                                db.curBranch.container.y/(db.curProb.probScale),
                                                db.stageDragContainer); 
      if (db.curProb.lIndex>0) {
       point2 = db.curProb.container.localToLocal(1,db.curLine.container.y,db.curProb.container);
       point.y += point2.y;
      }
    }
    else {
      point = db.curProb.container.localToLocal(branchX+db.curBranch.container.x/(db.curProb.probScale),
                                                db.curBranch.container.y/(db.curProb.probScale),
                                                db.stageDragContainer);
    }
  }
  else {
    if (db.curBranch.isBranch) {  
      point = db.curProb.container.localToGlobal(branchX+db.curBranch.container.x/(db.curProb.probScale),
                                                db.curBranch.container.y/(db.curProb.probScale)); 
      point.x = point.x/stage.scaleX;
      point.y = point.y/stage.scaleY;
      if (db.curProb.lIndex>0) {
       point2 = db.curProb.container.localToLocal(1,db.curLine.container.y,db.curProb.container);
       point.y += point2.y;
      }
    }
    else {
      point = db.curProb.container.localToGlobal(branchX+db.curBranch.container.x/(db.curProb.probScale),
                                                  db.curBranch.container.y/(db.curProb.probScale)); //,db.curProb.container);
      point.x = point.x/stage.scaleX;
      point.y = point.y/stage.scaleY;                                             
    }
    
  }
 
  db.xpos = point.x+db.curProb.halfGW*db.curBranch.bScale/db.curProb.probScale;
  db.ypos = point.y+ db.curProb.halfGH*db.curBranch.bScale/db.curProb.probScale;
  let cursorScale = db.curBranch.bScale;

  drawCursor(point.x, point.y);  
  } 
 
}

// passed in a point for a user click, in the problem container coordinatees, 
// determine which line of a multi-line problem the user clicked in, based on line heights.
// called from graphics-mouse file when the user clicks to the right of a line problem or other area that is within the 
// problem backgroundbox area but not within a branchbackgroundbox area
export function findClickedLine(point) {

  let tallyHeight = 0;  
  let clickedLine = 0;
  let lineIndex = -1;

  while (lineIndex++ < db.curProb.line.length-1 && point.y > tallyHeight) {
  
      tallyHeight += db.curProb.line[lineIndex].bHeightBot;
      if ((lineIndex+1) <= db.curProb.line.length-1) {
        tallyHeight += db.curProb.line[lineIndex+1].bHeightTop;
      }
      clickedLine = lineIndex;
  }
  return(clickedLine);

}

/* calculate the problem height above and below the standard starting xpos, based on the main branch lines in the problem
*/
export function resetTreeProbHeight() {


  db.curProb.heightAbove = db.curProb.line[0].bHeightTop;
  db.curProb.heightBelow = db.curProb.line[0].bHeightBot;
  let padding = (db.curProb.hasDivide) ? 0 : db.curProb.paddingHeight;
  for (let i = 1; i <= db.curProb.line.length-1; i++) {

    db.curProb.heightBelow += db.curProb.line[i].bHeightBot + db.curProb.line[i].bHeightTop + padding;

  }
  
 
}

/* calculate the problem height above and below the standard starting xpos, 
plus resets each lines container.y, Called after a line delete
*/
export function resetMoveTreeProbHeight() {


  db.curProb.heightAbove = db.curProb.line[0].bHeightTop
  db.curProb.heightBelow = db.curProb.line[0].bHeightBot;

  db.curProb.line[0].container.y = 0;

  let padding = (db.curProb.hasDivide) ? 0 : db.curProb.paddingHeight;
  for (let i = 1; i <= db.curProb.line.length-1; i++) {

    db.curProb.line[i].container.y = db.curProb.heightBelow + padding + db.curProb.line[i].bHeightTop;
    db.curProb.heightBelow += db.curProb.line[i].bHeightBot + padding + db.curProb.line[i].bHeightTop;                         
                    
  }

}



/* **
* adjusted Xpos returns equivalent of db.curProb container for the xpos
*/
export function adjustedXpos() {
  if (db.curProb.displayType == DISPLAY_TYPE_GRID || db.curProb.displayType == DISPLAY_TYPE_LINE) {
    return(db.xpos);
  }
  else {
    return(db.xpos - db.curProb.halfGW);
  }
}

export function adjustedYpos() {
  if (db.curProb.displayType == DISPLAY_TYPE_GRID || db.curProb.displayType == DISPLAY_TYPE_LINE) {
    return(db.ypos);
  }
  else {
    return(db.ypos - db.curProb.halfGH);
  }
}

/**
 * determine the location of where a abc text container box should be, based on converting
 * db.xpos and db.ypos to  either the curProb or curBranch
 */
export function convertXYforABCBox() {

  let point = new createjs.Point(0,0);
  if (db.inIpad) {
    if (db.mathLevel == 1 || db.mathLevel == 2 || db.curProb.displayType == DISPLAY_TYPE_GRID) {
      point = db.curProb.container.globalToLocal((db.xpos-db.curProb.halfGW+db.stageDragContainer.x)*stage.scaleX,
                                                (db.ypos-db.curProb.halfGH+db.stageDragContainer.y)*stage.scaleX);
      point.x *= db.curProb.probScale;
      point.y *= db.curProb.probScale;
    }
    else {
      point = db.curProb.container.globalToLocal((db.xpos-db.curProb.halfGW+db.stageDragContainer.x)*stage.scaleX,
        (db.ypos-db.curProb.halfGH+db.stageDragContainer.y)*stage.scaleX);
        point.x *= db.curProb.probScale;
        point.y *= db.curProb.probScale;
      
    }
  }
  else {
    if (db.mathLevel == 1 || db.mathLevel == 2 || db.curProb.displayType == DISPLAY_TYPE_GRID) {
      point = db.curProb.container.globalToLocal((db.xpos-db.curProb.halfGW)*stage.scaleX,
                                                  (db.ypos-db.curProb.halfGH)*stage.scaleX); 
      point.x *= db.curProb.probScale;
      point.y *= db.curProb.probScale;
    }
    else {
     
      point = db.curProb.container.globalToLocal((db.xpos-db.curProb.halfGW)*stage.scaleX,
                                                  (db.ypos-db.curProb.halfGH)*stage.scaleY); 
      point.x *= db.curProb.probScale;
      point.y *= db.curProb.probScale;
      
    }
  }

  
  return(point);
}

/* convert an XY from a mouse click into the coordinate system of the requested createjs object
*/

export function getCorrectXY(createjsObj) {

  let point = new createjs.Point(0,0);
  if (createjsObj) {
    point = createjsObj.globalToLocal(stage.mouseX, stage.mouseY);  
  }
  else {
    if (db.inIpad) {
      point = db.stageDragContainer.globalToLocal(stage.mouseX, stage.mouseY); 
    }
    else {
      point.x = stage.mouseX/stage.scaleY;
      point.y = stage.mouseY/stage.scaleY;
    }
  }              
  return(point);                               
}

export function removeChildFromStage(createjsObj) {
  if (db.inIpad) {
    db.stageDragContainer.removeChild(createjsObj);
  }
  else {
    stage.removeChild(createjsObj);
  }
}

export function countNewLines(str) {
  let lineCount = 1;
  for (let i = 0; i< str.length-1; i++) {
    if (str[i] == '\n') {
      lineCount++;
    }
  }
  return(lineCount);
}

export function removeNewLines(str) {
  let tempStr = '';
  for (let i = 0; i < str.length; i++) {
    if (str[i] != '\n') {
      tempStr = tempStr + str[i];
    }
  }
  return(tempStr);
}

/***
 * function pushUndoObj creates and pushes an undo object onto the undo stack, given the current math file object
 * It uses the pIndex already put on undoObj because this has been adjusted for deleted problems saved to mathFile
 */
export function pushUndoObj(mathFile, undoObj) {
 
  let limitCount = 5;
  undoObj.mathFile = mathFile;
  undoObj.state = (db.inPen) ? STATE_IN_PEN_TOOL : STATE_NORMAL;
  //console.log("pushUndo", mathFile);

  // write math problems 
  if (db.curProb != null) {
    undoObj.lIndex = db.curProb.lIndex;
    undoObj.sIndex = db.curLine.sIndex;
    undoObj.probState = db.probState;
    undoObj.curProbFracState = db.curProb.fracState;
  
    if (db.curProb.displayType == DISPLAY_TYPE_LINE) {
      undoObj.sIndex = db.curBranch.sIndex;
      
      if (db.curBranch.isBranch ) { 
  
        let nextBranch = db.curBranch;
        let undoBranchIndex;
        do {
          undoBranchIndex = new undoStackBranch(nextBranch.parentIndex, nextBranch.branchIndex);
          undoObj.branchList.push(undoBranchIndex);
          nextBranch = nextBranch.parent;

        }
        while (nextBranch.isBranch && limitCount-- > 0)
      }
      
    }
  }

  db.undoStack.push(undoObj);    // save the last math file to the undo stack 
}

// function findProbEndX calculates and returns the x offset of a last symbol in the math problem in x-coordinate units
// compared to the problem start
export function findProbEndX (mProb) {
  let endX = 0;
  if (mProb.displayType == DISPLAY_TYPE_GRID) {
    if (mProb.lIndex >= 0 ) {
        endX = (mProb.line[mProb.lIndex].sym.length)*mProb.gridW;
    }
  }
  // text problems have width in .w due to word wrap
  else if (mProb.displayType == DISPLAY_TYPE_TEXT) {
    endX = mProb.w;
  }
  else { // DISPLAY_TYPE_LINE - FIX
    if (mProb.lIndex >= 0 ) {
      endX = (mProb.line[mProb.lIndex].lineWidth)*mProb.gridW;
    }

  }
  return (endX);
}


export function findProbEndY (mProb) {
  let endY;
  if (mProb.displayType == DISPLAY_TYPE_GRID) {
    endY = (mProb.line.length-1)*mProb.gridH;
  }
  else {
    endY = mProb.h;
  }

  return(endY);
}

export function findProbSymX (mProb) {
  let endX = 0;
  if (mProb.lIndex >= 0 ) {
    let line = mProb.line[mProb.lIndex];
      endX = (line.sIndex+1)*mProb.gridW;
  }
  return (endX);
}


// calculates the y offset of the last symbol in the math problem in y-coordinate units
export function findProbLineY (mProb) {
  let endY = (mProb.lIndex)*mProb.gridH;
  return(endY);
}

export function setProbToPIndex(pIndex) {

  db.curProb = db.mProb[pIndex];
  if (db.curProb.displayType == DISPLAY_TYPE_GRID) {
    db.curLine = db.curProb.line.length-1;
    db.curLine.sIndex = db.curLine.length-1;
    db.xpos = db.curProb.xpos + findProbEndX(db.curProb);
    db.ypos = db.curProb.ypos + findProbEndY(db.curProb);
  }
}

/***
 * functin findNextPIndex is called after a problem is deleted, to find
 * the next pIndex to use.   First problems increasing up from given pIndex is searched,
 * then down, to find the first not deleted one.  If none are found, a pIndex of -1 is returned
 * problems that don't match the math level are skipped
 */
export function findNextPIndex (pIndex) {

  let findNext = pIndex+1;
  let probMax = db.mProb.length;
  while (findNext < probMax && (db.mProb[findNext].deleted || !db.mProb[findNext].matchLevel)) {
        findNext++;
      }
  if (findNext == probMax) {
    findNext = pIndex-1;
    while (findNext > -1 && (db.mProb[findNext].deleted || !db.mProb[findNext].matchLevel)) {
      findNext--;
    }
  }

  return (findNext);
}

/***
 * functin findPrevPIndex is called  to find
 * the pIndex before the current one.    First problems increasing up from given pIndex is searched,
 * then down, to find the first not deleted one.  If none are found, a pIndex of -1 is returned
 * problems that don't match the level are skipped
 */
 export function findPrevPIndex (pIndex) {

  let findNext = --pIndex;
  
  while (findNext >= 0 && (db.mProb[findNext].deleted || !db.mProb[findNext].matchLevel)) {
        findNext--;
      }

  return (findNext);
}

export function findLastProb() {
  let lastpIndex = db.mProb.length-1;
  while (lastpIndex > -1 && db.mProb[lastpIndex].deleted) {    
    lastpIndex--;
  }
  if (lastpIndex > -1) {
    db.xpos = db.mProb[lastpIndex].xpos;
    db.ypos = db.mProb[lastpIndex].ypos;
  }
  return(lastpIndex)
}

export function findLastMatchedProb() {
  let lastpIndex = -1;
  //lastpIndex = db.mProb.length-1;
  for (let i = db.mProb.length-1 ; i > -1 && db.mProb[i].deleted && !db.mProb[i].matchLevel ;i-- ) {
    lastpIndex = i;
  }
  
  if (lastpIndex > -1) {
    db.xpos = db.mProb[lastpIndex].xpos;
    db.ypos = db.mProb[lastpIndex].ypos;
  }

  return(lastpIndex)
}


export function findLastGridProb() {
  let lastpIndex = db.mProb.length-1;
  while (lastpIndex > -1 && 
    (db.mProb[lastpIndex].deleted || db.mProb[lastpIndex].displayType != DISPLAY_TYPE_GRID)) {    
    lastpIndex--;
  }
  return(lastpIndex)
}
/***
 * function deleteEmptyProb is called to delete a problem that has no symbols
 */
export function deleteEmptyProb(mProb) {

  if (mProb.backgroundBox != null) {
    mProb.backgroundBox.removeAllEventListeners();
    mProb.container.removeChild(db.curProb.container.backgroundBox);
  }
  removeChildFromStage(db.curProb.container);
     
  //db.mProb.splice(db.pIndex,1); 
  mProb.deleted = true; 
  db.cursor = null;
  //db.pIndex = findNextPIndex(db.pIndex);   currently called only from event handler that changes pIndex but might need to add something here

}
// return the type and size of font to use for the given KEYID
// in CSS format
export function getSymFont (keyID,typeCode,isCarry,tall)  {
    // initialize symbol font size and type to default font for current size setting
    // then change if needed for if passed symbol is specific symbol that uses other fonts
  
    let symFont;
    let symStyle = "";
  
    if (db.userPrefs.isDyslexic) {
      symFont = FONT_ALT;
    }
    else if (db.userPrefs.useBoldMathDisplay) {
      symFont = FONT_WITH_BOLD;  
      symStyle = "Bold ";
    }
    else {
      symFont = FONT_DEFAULT;  // default set to Vendana currently, more dyslexia friendly
    }

    let symSize = db.curProb.fontSize;
   
    
     // size determined by small, med, large current user preference 
    switch (typeCode) {                        // look at type of key entered to decide on font types
      case symConst.CV_OPERATOR_TYPE:          // operators are in cambria math
        //symFont = FONT_MATH;
        //symSize = db.curProb.fontSize;  // may want to add math size scaling factor as contstant
        if (keyID === symConst.KEY_ID_MULTIPLY_2) {     // make multiply dot bigger
          symSize *= 2;    // fix this, need to make multiply dot larger based on current size
          symFont = FONT_MATH;
        }
        break;
      //case symConst.CV_EQUALS_INQ_TYPE: // Equal and inequality are cambria math font
      //  symSize = db.curProb.fontSize;
      //  symFont = FONT_MATH;
      //  break;

      // Geometry symbols have no glyphs in Verdana, so without these the device substitutes its
      // own font - which is why the parallel sign was slanted on Chromebook/iPad.
      case symConst.CV_GEO_SYMBOL:
      case symConst.CV_GEO_SHAPE:
      case symConst.CV_GEO_PROOF:
        symFont = FONT_GEO_NOTO;
        break;

      case symConst.CV_EQUALS_INQ_TYPE:  // geometry relations use DejaVu, the rest keep the default
        switch (keyID) {
          case symConst.KEY_ID_CONGRUENT:
          case symConst.KEY_ID_SIMILAR:
          case symConst.KEY_ID_NOT_SIMILAR:
            symFont = FONT_GEO_DEJAVU;
            break;
          default:
            break;
        }
        break;

      case symConst.CV_BRACKET_TYPE:
        switch (keyID) {
          case symConst.KEY_ID_PAREN_RIGHT:
          case symConst.KEY_ID_PAREN_LEFT:
            if (tall) {
              symFont = "Lato";
            }
            break;
          default:
            break;
        }
        break;
      case symConst.CV_SPECIAL_TYPE: // decimal point is extra large
        if (keyID === symConst.KEY_ID_DECIMAL) {
          //symSize = '32px ';     // fix this, need to add something to make decimal larger
        }
        break;
      
      case symConst.CV_SUM_LIMIT_TYPE:
        if (keyID == symConst.KEY_ID_SUMMATION || keyID == symConst.KEY_ID_INTEGRAL) {
          symFont = FONT_MATH;
          symStyle = "";
        }
        break;
      case symConst.CV_UNITS_TYPE:            
        if (keyID === symConst.KEY_ID_PERCENT) {
          if (!db.userPrefs.isDyslexic) {
            symFont = FONT_SPEC_2; 
          }           // Calibri for precent because verdana is to wide for this symbol
        }
      case symConst.CV_MISC_TYPE:           // some misc symbols don't have vendana versions so are 
   
        switch (keyID) {                    // a variety of fonts
          case symConst.KEY_ID_LIMIT_ARROW:
            symFont = FONT_WINGDINGS;
            symSize = symSize*.7;
            symStyle = "";
            break;
          case symConst.KEY_ID_INFINITY:
            if (!db.userPrefs.isDyslexic) {
             symFont = (db.userPrefs.useBoldMathDisplay) ? FONT_MATH : "Lato";
            }
            //symStyle = "Bold";
            break;
          case symConst.KEY_ID_COMMA:
          
            if (!db.userPrefs.isDyslexic) {
               symFont = FONT_SPEC_1; // cambria for : , ! because this just looks better
            }
            break;
         
          case symConst.KEY_ID_FACTORIAL:
          case symConst.KEY_ID_UNION:
          case symConst.KEY_ID_INTERSECT:
          case symConst.KEY_ID_ELEMENT:
          case symConst.KEY_ID_PI:
          case symConst.KEY_ID_ANGLE_VALUE:
            if (!db.userPrefs.isDyslexic) {
             symFont = FONT_MATH;
            }
            //symSize = db.curProb.fontSize;    // consider math size scale
          break;

          case symConst.KEY_ID_CHEM_ARROW:
          case symConst.KEY_ID_LEFT_ARROW:
          case symConst.KEY_ID_CHEM_DB_ARROW:
          
            symFont = FONT_MATH;
            break;
            
          case KEY_ID_ALT_E:  
          //case symConst.KEY_ID_I:
             symFont = FONT_SPEC_2;       // these need to be italic Cambria
             symStyle = FONT_ITALIC;
          break;
        
          case symConst.KEY_ID_CHECKMARK:
            symFont = FONT_WINGDINGS;
            symStyle = "";
            break;
          default: // defaults are left as initialized value
        }
      default:
    }
    // adjust font size to counter stage scale
 
  if ((db.mathLevel == 1 || db.mathLevel == 2 || db.curProb.displayType == DISPLAY_TYPE_GRID) && (keyID.length > 1)) {
    if (keyID == symConst.KEY_ID_X_SQR || keyID == symConst.KEY_ID_Y_SQR) {
      symSize = symSize * .8;
    }
    else {
      symSize = symSize * UNITS_GRID_SCALE;
    }
  }
  
  // change to small font for a carry position symbol
  if (isCarry) {
    symSize = symSize * 0.5;
  }
  else if (tall) {
    symSize = symSize * 2;
  }

    if (db.probState == STATE_ROOT_FIRST) {

    symSize = symSize * .7;
  }
  else if (db.curProb.fracState == STATE_IN_GRID_FRACTION_NUM ||
            db.curProb.fracState == STATE_IN_GRID_FRACTION_DEN) {
    symSize = symSize * .7;
  }
  
  if (db.curProb.displayType == DISPLAY_TYPE_LINE && db.curBranch != null && db.curBranch.isBranch) {
   
    symSize = symSize * db.curBranch.bScale;
  }
  
  symSize = symSize.toString() + 'px ';

  return symStyle + symSize + symFont; // return a css style font size and name string
}
   
